import type { MenuItemProps } from 'react-aria-components';
import { MenuItem as AriaMenuItem, composeRenderProps } from 'react-aria-components';

import { Check } from '@repo/media/icons';

import { composeTailwindRenderProps } from '../utils.ts';
import { menuItemStyles } from './menu-styles.ts';

export function MenuItem({ className, ...props }: Omit<MenuItemProps, 'className'> & { className?: string | undefined }) {
  return (
    <AriaMenuItem {...props} className={composeTailwindRenderProps(menuItemStyles, className)}>
      {composeRenderProps(props.children, (children, { isSelected, selectionMode }) => (
        <>
          {selectionMode !== 'none' && (
            <span className="flex items-center w-5">
              {isSelected && <Check className="w-4 h-4" />}
            </span>
          )}
          <span className="flex items-center flex-1 gap-2 font-normal truncate group-selected:font-semibold">
            {children}
          </span>
        </>
      ))}
    </AriaMenuItem>
  );
}
